/* eslint-disable react/no-danger-with-children */
import React from 'react';
import { Box, Container, Heading, Img, Text } from '@chakra-ui/react';

interface IAboutPersonLayoutProps {
  data: any;
  bgGradient?: string;
  bgColor?: string;
}

const RenderHTML = (props: { HTML: any }) => (
  // eslint-disable-next-line react/no-danger, react/destructuring-assignment
  <span dangerouslySetInnerHTML={{ __html: props.HTML }} />
);

const AboutPersonLayout: React.FunctionComponent<IAboutPersonLayoutProps> = ({
  data,
  bgGradient = 'linear(to-r, primary.500, secondary.500)',
  bgColor,
}) => (
  <>
    <Box w="100%" bgGradient={bgGradient} bgColor={bgColor}>
      <Container maxW="container.xl" py="80px">
        <Heading
          mb="20px"
          variant="reportCardTitle"
          fontSize="38px"
          color="white"
          lineHeight="32px"
        >
          {data.name}
        </Heading>
        <Text fontSize="22px" fontWeight="600" color="white" lineHeight="28px">
          {data.position || data?.designation}
        </Text>
      </Container>
    </Box>
    <Container
      maxW="container.xl"
      py="80px"
      minH="420px"
      display={{ xs: 'flex', md: 'inherit' }}
      flexDirection="column"
    >
      <Img
        src={data.image.location}
        alt={data.name}
        boxSize="300px"
        float={{ xs: 'right', md: 'left' }}
        alignSelf={{ xs: 'center', md: 'flex-start' }}
        mx={{ xs: '0px', md: '0px' }}
        mr={{ xs: '0px', md: '70px' }}
        mb="20px"
        objectFit="cover"
        filter={data.name === 'Niharika Bisht' ? 'grayscale(90%)' : 'none'}
      />
      <Box>
        <Heading textAlign={{ xs: 'center', md: 'left' }} fontWeight="800">
          {data.name}
        </Heading>
        <Box
          ml={{ xs: 'auto', md: '370px' }}
          mr={{ xs: 'auto', md: '0px' }}
          width={{ xs: '160px', md: '80px' }}
          h="2px"
          bgColor="primary.500"
          borderRadius="5px"
          mt={{ xs: '16px', md: '10px' }}
          mb="15px"
        />
        <Heading
          textAlign={{ xs: 'center', md: 'left' }}
          variant="milestone"
          fontSize="19px"
          mb="15px"
          lineHeight="28px"
        >
          {data.position || data?.designation}
        </Heading>
        <Text
          fontSize="18px"
          fontWeight="500"
          color="text.mediumBlack"
          lineHeight="28.5px"
          textAlign="justify"
        >
          {data.details_link ? (
            data.details_link
          ) : (
            // eslint-disable-next-line react/no-danger
            <RenderHTML HTML={data.about} />
          )}
        </Text>
      </Box>
    </Container>
  </>
);

export default AboutPersonLayout;
